var exports = {
  "n": "xfb577c5e--244e8c--link",
};

module.exports = exports;
